import react, { useMemo } from 'react';

export const useMergeBtns = ({ bottomFreeBtns, optionList }: any) => {
  const renderFreeBtns = bottomFreeBtns.map((btn: any) => {
    return {
      ...btn,
      isFreeBtn: true,
    };
  });
  return {
    renderBtnList: renderFreeBtns.concat(optionList),
  };
};
